'use client';

import { AUTHORITY_CODE } from '@/lib/utils';
import { useParams } from 'next/navigation';
import Script from 'next/script';
import { useState } from 'react';
import useSWR from 'swr';

export function OnlineConsultant() {
  const [srcVerboxLink, setSrcVerboxLink] = useState('https://admin.verbox.ru/support/support.js');
  const { locale } = useParams();

  const localeForWidget = locale === 'oz' || locale === 'qr' ? 'uz' : locale;

  const { data: chat } = useSWR<{ value: string; walk_talk: string | null }>(
    AUTHORITY_CODE !== 'soliq' ? ['/authorities/main/get-chat-id'] : null,
  );

  if (AUTHORITY_CODE === 'soliq') {
    return (
      <>
        {/* <Script src="https://www.chatbase.co/embed.min.js" strategy="lazyOnload" defer />;
        <Script id="soliq-chatbot-script" strategy="lazyOnload" defer>
          {`window.embeddedChatbotConfig = {
              chatbotId: "34Rn-LeaYcF6VilAkErpt",
              domain: "www.chatbase.co"
            }`}
        </Script> */}
        <Script src="https://ai.yt.uz/widgetchat.js" strategy="lazyOnload" defer />
      </>
    );
  }

  if (AUTHORITY_CODE === 'mc') {
    return <Script src="https://ai.shaffofqurilish.uz/shaffof_chatbot/chat-widget.js" strategy="lazyOnload" defer />;
  }
  return chat?.value?.trim() ? (
    <>
      <Script
        src="https://uhamkor.uz/widget/widget.js"
        data-project-uuid={chat?.value}
        data-language={localeForWidget}
        strategy="lazyOnload"
        defer
      />
    </>
  ) : null;
}
